import React from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";

import styled from "@emotion/styled";
import logo from "../../images/logo.png";
import servicesbg from "../../images/servicesbg.png";

const Items = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  // opacity: 0.8;
  font-size: 12px !important;
  font-family: "PoppinsLight";
  color: black;
`;
const Img = styled.div`
  background-image: url(${servicesbg});
  background-repeat: no-repeat;
  min-height: 47vh;
  background-size: cover;
  repeat: no-repeat;
  background-position-x: center;
  position: relative;
`;
const ImgText = styled.div`
  font-size: 70px;
  padding-top: 120px;
  font-weight: 900;
  color: #ffffff;
  text-align: center;
  @media (max-width: 768px) {
    padding-top: 100px;
  }
`;

const Index = (props) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  return (
    <div>
      <AppBar
        position="static"
        style={{
          color: "white",
          backgroundColor: "white",
          boxShadow: "none",
          padding: "30px 0 5px",
          zIndex: "9999999999999999999999",
        }}
      >
        <Container maxWidth="xl">
          <div
            maxWidth="xl"
            style={{
              // paddingLeft: "20px",
              // paddingRight: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <a href="/#">
                <img
                  src={logo}
                  alt="logo"
                  className="img-fluid"
                  style={{ width: 400, paddingTop: 0, paddingBottom: 10 }}
                />
              </a>
            </Typography>

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              <a href="/#">
                <img
                  src={logo}
                  alt="logo"
                  className="img-fluid"
                  style={{ width: 300, paddingTop: 0, paddingBottom: 10 }}
                />
              </a>
            </Typography>

            <Box
              sx={{
                justifyContent: "right",
                flexGrow: 50,
                color: "white",
                display: { xs: "none", md: "flex" },
              }}
            >
              <a style={{ textDecoration: "none" }} href="/">
                <Items>
                  <MenuItem>Home</MenuItem>
                </Items>
              </a>
              <a style={{ textDecoration: "none" }} href="/#about">
                <Items>
                  <MenuItem>About</MenuItem>
                </Items>
              </a>
              <a style={{ textDecoration: "none" }} href="/services">
                <Items>
                  <MenuItem>Services</MenuItem>
                </Items>
              </a>

              <a style={{ textDecoration: "none" }} href="/gallery">
                <Items>
                  <MenuItem>Gallery</MenuItem>
                </Items>
              </a>

              <a style={{ textDecoration: "none" }} href="/#contact">
                <Items>
                  <MenuItem>Contact</MenuItem>
                </Items>
              </a>
              <a
                href="tel:+92 333 5702025"
                style={{ textDecoration: "none", color: "white" }}
              >
                <Items>
                  <MenuItem>+92 333 5702025</MenuItem>
                </Items>
              </a>
            </Box>
            <Box
              sx={{
                justifyContent: "flex-end",
                flexGrow: 1,
                color: "white",
                display: { xs: "none", md: "flex" },
              }}
            >
              {/* <Button>Buy Now</Button> */}
            </Box>

            <Box sx={{ flexGrow: 0, display: { xs: "flex", md: "none" } }}>
              <IconButton
                style={{ color: "black" }}
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <a href="/#home">
                  <MenuItem
                    style={{ color: "black" }}
                    onClick={() => handleCloseNavMenu("/")}
                  >
                    Home
                  </MenuItem>
                </a>
                <a href="/#about">
                  <MenuItem
                    style={{ color: "black" }}
                    onClick={() => handleCloseNavMenu("/")}
                  >
                    About
                  </MenuItem>
                </a>
                <a href="/services">
                  <MenuItem
                    style={{ color: "black" }}
                    onClick={() => handleCloseNavMenu("/")}
                  >
                    Services
                  </MenuItem>
                </a>

                <a href="/gallery">
                  <MenuItem
                    style={{ color: "black" }}
                    onClick={() => handleCloseNavMenu("/")}
                  >
                    Gallery
                  </MenuItem>
                </a>
                <a href="/#contact">
                  <MenuItem
                    style={{ color: "black" }}
                    onClick={() => handleCloseNavMenu("/")}
                  >
                    Contact
                  </MenuItem>
                </a>
                <a href="tel:+92 333 5702025">
                  <MenuItem
                    style={{ color: "black" }}
                    onClick={() => handleCloseNavMenu("/")}
                  >
                    +92 333 5702025
                  </MenuItem>
                </a>
              </Menu>
            </Box>
          </div>
        </Container>
      </AppBar>

      <Img>
        <ImgText> {props.children}</ImgText>
      </Img>
    </div>
  );
};

export default Index;
